<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu></leftmenu>
        <!-- 我的分数 -->
        <div class="main_r">
          <div class="mainr_top">
            <div><img src="@/assets/gerenzhongxin/geren16.png">
              分数位次
            </div>
            <div class="serachkuang" v-if="userInfo.userRole == '3' || userInfo.userRole == '2'">
              <el-select  v-model="rankArea" class="inpda" placeholder="请选择省份">
                <el-option v-for="item in areaList" :key="item.areaId" :label="item.areaName" :value="item.areaId">
                </el-option>
              </el-select>

            </div>
            <div class="serachkuang">
              <el-select v-model="rankYear" placeholder="请选择年份" multiple>
                <el-option v-for="(item,index) in 10" :key="year-index" :label="year-index" :value="year-index">
                </el-option>
              </el-select>
            </div>
            <div class="serachkuang">
              <el-select v-model="rankSubject" placeholder="请选择科目">
                <el-option v-for="(item,index) in SUBJECTTYPELIST" :key="item.id" :label="item.type" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="serachkuang">
              <input placeholder="分数开始" type="number" v-model="rankScore" @keydown.enter="search" />
              —
              <input placeholder="分数截止" type="number" v-model="rankScoreAdd" @keydown.enter="search" />
            </div>
            <div class="serachkuang">
              <div class="sousuo" @click="search">
                查&nbsp;&nbsp;询
              </div>
              <div style="margin-left: 20px;" class="sousuo del" @click="delsearch">
                清&nbsp;&nbsp;空
              </div>
            </div>
          </div>
          <div class="xs_ul">
            <div class="fenbuBox">
              <div class="fenbu" id="fenbu" style="height: 500px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu
    },
    data() {
      return {
        list: [],
        obj: {
          score: [],
          yearlist: []
        },
        userInfo: this.$utils.getlocalStorage('userInfo'),
        scoreInfo: this.$utils.getlocalStorage('scoreInfo'),
        year: new Date().getFullYear(),
        rankYear: [],
        areaList: this.$utils.getlocalStorage('AREA_LIST_ADMIN'),
        SUBJECTTYPELIST: this.$utils.getlocalStorage('SUBJECTTYPELIST'),
        rankScore: null,
        rankArea: null,
        rankSubject: null,
        rankScoreAdd: null,
        myChart: null
      }
    },
    mounted() {
      // this.tupiao()
      this.rankArea = this.scoreInfo.scoreArea
      this.rankSubject = this.scoreInfo.scoreSubject
      this.myChart = this.$echarts.init(document.getElementById('fenbu'));
      this.getdata()
      let _this = this;
      window.addEventListener('resize', function() {
        _this.myChart.resize()
      })
    },


    methods: {
      search() {
        this.getdata()
      },
      delsearch() {
        this.rankArea = this.scoreInfo.scoreArea
        this.rankSubject = this.scoreInfo.scoreSubject
        this.rankYear = []
        this.rankScore=null
        this.rankScoreAdd=null
        this.getdata()
      },

      getdata() {
        if (this.rankScore < this.rankScoreAdd) {
          let a = this.rankScore;
          this.rankScore = this.rankScoreAdd;
          this.rankScoreAdd = a;
        }
        let _this = this;
        let query = {
          rankArea: this.rankArea,
          rankSubject: this.rankSubject,
          rankScore: this.rankScore,
          rankScoreAdd: this.rankScoreAdd,
          rankYears: this.rankYear.join(",")
        }
        if(this.userInfo.userRole != '3' && this.userInfo.userRole != '2'){
          query.rankArea= this.userInfo.userProvinces
        }
        _this.$req.queryAllScoreRank({
          pageSize: 10,
          pageNum: 1,
          queryObj: query
        }).then(function(response) {
          _this.obj = response.data
          _this.tupiao()
        })
      },
      tupiao() {
        let _this = this;
        let list = [];
        for (let i in this.obj.yearlist) {
          console.log(i)
          list.push({
            name: _this.obj.yearlist[i],
            type: 'line',
            yAxisIndex: 0,
            data: _this.obj[_this.obj.yearlist[i]]
          })
          list.push({
            name: _this.obj.yearlist[i] + "T",
            type: 'bar',
            yAxisIndex: 1,
            data: _this.obj[_this.obj.yearlist[i] + "T"]
          })
        }
        console.log(list)
        var option = {
          animation: true,
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
              // params 是一个数组，数组中包含每个系列的数据信息
              let result = params[0].axisValue + '(分)</br>';
              let result1 = '';
              let result2 = '';

              params.forEach(function(item) {
                // item 是每一个系列的数据
                let seriesName = item.seriesName; // 系列名称
                const value = item.value; // 数据值
                const marker = item.marker; // 标志图形
                if (seriesName.indexOf("T") != -1) {
                  seriesName = seriesName.replace("T", '分段人数')
                  result2 += `${marker}${seriesName}: ${value}  (人)<br/>`;
                } else {
                  result += `${marker}${seriesName}: ${value}  (位)<br/>`;
                }
              });
              return result + result2;
            },
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: [{
              data: this.obj.yearlist,
              // icon: 'roundRect',
              x: 'center',
              y: '2%',
              textStyle: {
                color: '#B2D9FF',
                fontSize: 12
              }
            },
            {
              data: this.obj.yearlistT,
              // icon: 'roundRect',
              x: 'center',
              y: '6.5%',
              textStyle: {
                color: '#B2D9FF',
                fontSize: 12
              }
            }
          ],

          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.obj.score
          },
          yAxis: [{
            type: 'value',
            name: '位次',
            axisLabel: {
              formatter: '{value} 位'
            }
          }, {
            type: 'value',
            name: '分段人数',
            axisLabel: {
              formatter: '{value} 人'
            }
          }],
          dataZoom: [{
              type: 'inside',
              start: 0,
              end: 100
            },
            {
              start: 0,
              end: 5
            }
          ],
          series: list
        }

        // 使用刚指定的配置项和数据显示图表。
        _this.myChart.setOption(option);
      }
    },
    created() {

      console.log(this.rankArea)
      // this.getdata();
    }
  }
</script>

<style scoped>
  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    margin-top: 70px;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  .jibenxinxi {
    width: 290px;
    height: 700px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1050px;
    min-height: 878px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }


  .duanxin {
    border: none;
    position: absolute;
    left: 340px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-left: 0px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 0px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 230px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  input::placeholder {
    color: #a4a4a4;
  }

  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 690px;
    height: 520px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: rgb(235 232 230);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .uppwd {
    display: flex;
    flex-direction: row;
  }
























  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 200px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  /* 我的学生 */
  .xs_ul {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* .xs_ul_you{width: 100%;height: auto; } */
  .xs_li {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 20px;
    width: 100%;
    /* height: 64px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background: url(../../assets/gerenzhongxin/wdxs2.png)no-repeat;
    background-size: 100% 100%;
  }

  .xs_li_r {
    padding: 0 10px;
    height: 28px;
    background: linear-gradient(180deg, #F53824 0%, #FE9603 100%);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .xs_li_r_e {
    background: unset;
    color: #F53824;
    border: 1px solid #F53824;
  }

  .xs_li_l {
    display: flex;
    height: 100%;
    align-items: center;
  }

  .xs_li_l figure {
    display: flex;
    height: 100%;
    align-items: center;
  }

  .xs_li_l figure img {
    height: 46px;
    margin-right: 10px;
  }

  .xs_li_l figure figcaption {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
  }

  .xs_li_l span {
    margin-left: 0px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .xs_li_c {
    display: flex;
    height: 100%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .xs_li_c span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .xs_li_c span:nth-of-type(2) {
    margin-left: 15px;
  }

  .mieyou {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .serachkuang {
    display: flex;
    width: 150px;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .serachkuang input {
    border: none;
    width: 80px;
    height: 40px;
    background: #fff;
    font-size: 14px;
    opacity: 1;
    border-radius: 4px;
    padding-left: 15px;
    border: 1px solid #E0E0E0;
  }

  .sousuo {
    cursor: pointer;
    width: 80px;
    height: 25px;
    font-size: 15px;
    color: #fff;
    line-height: 25px;
    font-family: PingFang SC;
    font-weight: 800;
    padding: 0px 15px 0px 15px;
    background: linear-gradient(180deg, #F53824 0%, #FE9603 100%);
    border-radius: 6px;
  }

  .del {
    color: #F53824;
    background: #FFFFFF;
    border: 1px solid #F53824;
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/k_scorerank.vue